import styled from 'styled-components';

const AboutUsHeroStyle = styled.div`
	--titleMaxWidth: var(--sp34x);
	--titleMargin: var(--sp23x) var(--sp16x) 0 0;
	--imageWidth: 40%;
	--imagePaddingTop: 47.3%;
	--infoMaxWidth: var(--sp58x);
	--infoMargin: var(--sp11x) 0 0 var(--sp12x);
	--infoParagraphMarginTop: var(--sp2-5x);

	.about-us-hero-container {
		display: flex;

		.about-us-title {
			max-width: var(--titleMaxWidth);
			margin: var(--titleMargin);
			transform: translateX(-200px);
			opacity: 0;
		}

		.about-us-image {
			--proportion: var(--imagePaddingTop);

			width: var(--imageWidth);
			transform: scale(0.7);
			transform-origin: bottom;
			opacity: 0;
		}

		.info {
			max-width: var(--infoMaxWidth);
			margin: var(--infoMargin);
			transform: translateX(200px);
			opacity: 0;

			h2 {
				font-size: var(--h2L);
				font-family: var(--futura);
				font-weight: 500;
				color: var(--purple);
				margin-bottom: var(--infoParagraphMarginTop);
			}

			p {
				font-size: var(--h5);
				font-family: var(--futura);
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--titleMaxWidth: var(--sp27x);
		--titleMargin: var(--sp21x) var(--sp12x) 0 0;
		--imageWidth: 40%;
		--infoMaxWidth: var(--sp53x);
		--infoMargin: var(--sp10x) 0 0 var(--sp8x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--titleMaxWidth: var(--sp27x);
		--titleMargin: var(--sp21x) var(--sp8x) 0 0;
		--imageWidth: 40%;
		--infoMaxWidth: var(--sp46x);
		--infoMargin: var(--sp8x) 0 0 var(--sp8x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--titleMaxWidth: var(--sp22x);
		--titleMargin: var(--sp14x) var(--sp6x) 0 0;
		--imageWidth: 40%;
		--infoMaxWidth: var(--sp37x);
		--infoMargin: var(--sp4x) 0 0 var(--sp6x);
		--infoParagraphMarginTop: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--titleMaxWidth: var(--sp22x);
		--titleMargin: 0 0 var(--sp3x) 0;
		--imageWidth: 61.2%;
		--imagePaddingTop: 75.5%;
		--infoMaxWidth: var(--sp51x);
		--infoMargin: var(--sp3x) 0 0 0;
		--infoParagraphMarginTop: var(--sp2x);

		.about-us-hero-container {
			flex-direction: column;

			.info {
				margin-left: auto;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--titleMaxWidth: var(--sp22x);
		--titleMargin: 0 0 var(--sp2x) 0;
		--imageWidth: 100%;
		--imagePaddingTop: 123.3%;
		--infoMaxWidth: 100%;
		--infoMargin: var(--sp3x) 0 0 0;
		--infoParagraphMarginTop: var(--sp1-5x);

		.about-us-hero-container {
			flex-direction: column;
		}
	}
`;

export default AboutUsHeroStyle;
